import React, { memo } from "react";
import Modal from "../../shared/Modal";
import PaymentMethodsList from "../../shared/PaymentMethodsList";
import { prefix } from "../../../../i18n";

const tCartCheckout = prefix("cart-checkout");

const CoPaymentModal = memo(
  ({
    show,
    close,
    campaignRate,
    debtPoints,
    paymentMethods,
    handleMethodChoosing,
  }) => {
    return (
      <Modal show={show} untoggle={close}>
        <div className="gl2026-modal__header">
          <h4 className="gl2026-modal__title">{tCartCheckout("choose-payment-method")}</h4>
        </div>
        <div className="gl2026-modal__body">
          <PaymentMethodsList
            campaignRate={campaignRate}
            debtPoints={debtPoints}
            methods={paymentMethods}
            handleMethodChoosing={handleMethodChoosing}
          />
        </div>
      </Modal>
    );
  },
);

export default CoPaymentModal;
